<template>
    <el-menu class="el-menu-demo" mode="horizontal"  background-color="#fff"  text-color="#000" active-text-color="#409EFF" :ellipsis="false">
        <div class="header-page-title" v-if="pageTitle">
            <span class="header-title-text">{{ pageTitle }}</span>
            <span class="header-subtitle-text" v-if="pageSubtitle">{{ pageSubtitle }}</span>
        </div>
        <el-row  class="ly-header-right">
            <el-badge :value="msgLen" class="item" @click="show()" v-if="curRole=='admin'">
                <el-icon size="large"> <bell /></el-icon>
            </el-badge>
            <span style="margin-left:30px;">
                <el-dropdown trigger="click" class="right-dropdown-center">
                <span class="el-dropdown-link">
                  你好,{{userName}}
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                      <div v-show="hasPermission('personalCenter','Search')">
                          <el-dropdown-item @click="jumpto" ><el-icon><User /></el-icon>个人中心</el-dropdown-item>
                      </div>
                      <el-dropdown-item @click="exit"><el-icon><Close /></el-icon>退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </span>
        </el-row>
        
        <el-dialog v-model="dialogVisible" customClass="dddd" :close-on-click-modal="false" title="告警列表" width="80%" style="z-index:9999;">
          <el-table stripe :data="warningList" ref="tableref" style="width: 100%">
            <el-table-column type="index" width="60" align="center" label="序号">
                <template #default="scope">
                    <span v-text="getIndex(scope.$index)"></span>
                </template>
            </el-table-column>
            <el-table-column width="120" prop="linkId" label="账户"></el-table-column>
            <el-table-column prop="warning" label="告警信息"></el-table-column>
          </el-table>
          <el-pagination style="justify-content: center;margin-top:20px;" layout="prev, pager, next" :page-size="15" :total="total" @current-change="handleCurrentChange" v-model:currentPage="curPage"> </el-pagination>
        </el-dialog>
    </el-menu>
  </template>
  <script setup>
      import {ref, onMounted,onBeforeUnmount,getCurrentInstance,nextTick,computed} from 'vue'
      import { ElMessage , ElMessageBox,ElNotification } from 'element-plus'
      import screenfull from 'screenfull'
      import {useMutitabsStore} from "@/store/mutitabs";
      import {useSiteThemeStore} from "@/store/siteTheme";
      import {useRouter,useRoute} from 'vue-router'
      var noticeLen = ref(localStorage.getItem('len')||0);
      var msgLen = ref(0);
      var dialogVisible = ref(false);
      var timer = null;
      var warningList = ref([]);
      var html = '',cont='';
      var curPage = ref(1);
      var total = ref(0);
      var notification=null,notification1=null;
      var curRole = ref(localStorage.getItem('curRole')||'');
      const showNotice = ()=>{
        notification = ElNotification({
          title: '提示',
          duration: 0,
          type:'warning',
          dangerouslyUseHTMLString: true,
          message: html
        });
      }
      const showNotice1 = ()=>{
        notification1 = ElNotification({
          title: '提示',
          duration: 0,
          type:'warning',
          dangerouslyUseHTMLString: true,
          message: cont
        });
      }
      const show = ()=>{
        showNotice();
        if(warningList.value.length>0){
          setTimeout(()=>{
            showNotice1()
          },100)
        }
      }
      // if(warningList.length>0){
      //   warningList.forEach(el=>{
      //     var cont = `<p style="font-size:16px;">当前账户：${el.linkId}</p><p>${el.warning}</p>`;
      //     ElNotification({
      //       title: '提示',
      //       duration: 0,
      //       type:'warning',
      //       dangerouslyUseHTMLString: true,
      //       message: cont
      //     });
      //   })
      // }
      timer = setInterval(()=>{
        if(localStorage.getItem('len')){
            clearInterval(timer);
            noticeLen.value = localStorage.getItem('len');
            html = 
            `<p style="font-size:16px;">当前有${noticeLen.value}条linker未创建，请<a style="font-size:16px;color:#409eff;cursor:pointer" onclick='jump()'>查看</a></p>`;
            if(noticeLen.value>0&&(curRole.value=='admin'||curRole.value=='sales')){
                msgLen.value=1;
                showNotice()
            }else if(noticeLen.value == 0){
                msgLen.value = 0;
            }
        }
        
        const warningListData = localStorage.getItem('warningList');
        if (warningListData) {
            const parsedWarningList = JSON.parse(warningListData);
            total.value = parsedWarningList.length;
            if(total.value > 15) {
                warningList.value = parsedWarningList.slice(0, 15);
            } else {
                warningList.value = parsedWarningList;
            }
            
            if(warningList.value.length > 0) {
                cont = `<p style="font-size:16px;">当前有${total.value}条账户异常告警，请<a style="font-size:16px;color:#409eff;cursor:pointer" onclick='jump(1)'>查看</a></p>`
                if(curRole.value != 'customer') {
                    msgLen.value++;
                    setTimeout(()=>{
                        showNotice1()
                    }, 200)
                }
            }
        } else {
            total.value = 0;
            warningList.value = [];
        }
      },1000);
      const timer1 = setInterval(()=>{
        const newLen = localStorage.getItem('len');
        if(newLen != noticeLen.value){
            noticeLen.value = newLen;
            html = 
            `<p style="font-size:16px;">当前有${noticeLen.value}条linker未创建，请<a style="font-size:16px;color:#409eff;cursor:pointer" onclick='jump()'>查看</a></p>`
        }
      },1000)
      if(curRole.value!='admin'){
        clearInterval(timer1);
        clearInterval(timer);
      }
      const router = useRouter()
      const route = useRoute()
      
      // 页面标题映射（原型 Home.tsx PAGE_DESCRIPTIONS）
      const pageTitleMap = {
        'billManage': { title: '账单管理', subtitle: '账单的查询、下载、对账与核对' },
        'linkerManage': { title: 'Link管理', subtitle: '客户账户关联与归属管理' },
        'payerManage': { title: 'Payer管理', subtitle: '付款账户配置与管理' },
        'agentManage': { title: '伙伴管理', subtitle: '合作伙伴信息管理' },
        'customerManage': { title: '客户管理', subtitle: '客户信息查询与管理' },
        'personalCenter': { title: '个人中心', subtitle: '账户设置与个人信息' },
        'authorityManage': { title: '权限管理', subtitle: '角色与权限配置' },
        'roleManage': { title: '角色管理', subtitle: '' },
        'menuManage': { title: '菜单管理', subtitle: '' },
        'buttonManage': { title: '按钮管理', subtitle: '' },
        'departManage': { title: '部门管理', subtitle: '' },
        'loginLog': { title: '登录日志', subtitle: '' },
        'downloadLog': { title: '下载日志', subtitle: '' },
        'organizationManage': { title: '组织管理', subtitle: '' },
        'adminManage': { title: '管理员管理', subtitle: '' },
        'saleManage': { title: '销售管理', subtitle: '' },
        'SalesOverview': { title: 'Sales Overview', subtitle: '实时销售数据概览与分析' },
        'BillAnalysis': { title: 'Bill Analysis', subtitle: '按实体查看月度费用统计与趋势' },
        'BillDetailView': { title: 'Bill Detail', subtitle: 'All entities monthly cost breakdown' },
        'costOverview': { title: 'Cost Overview', subtitle: '成本概览与费用分析' },
        'costExplorer': { title: 'Cost Explorer', subtitle: '多维度费用探索与筛选' },
        'rispSummary': { title: 'RI/SP 分析', subtitle: '预留实例与节省计划使用分析' },
        'costAlerts': { title: '费用告警', subtitle: '费用异常监控与告警配置' },
        'overdueManage': { title: '逾期管理', subtitle: 'AWS 与 SOA 双源核对的逾期发票监控与催款' },
      }
      const pageTitle = computed(() => {
        const name = route.name
        return pageTitleMap[name]?.title || ''
      })
      const pageSubtitle = computed(() => {
        const name = route.name
        return pageTitleMap[name]?.subtitle || ''
      })
      
      const jump = (type)=>{
        if(type){
          // ElMessageBox.alert(warning, '告警账户'+id, {
          //   confirmButtonText: '确定',
          //   callback: (action) => {
          //     // ElMessage({
          //     //   type: 'info',
          //     //   message: `action: ${action}`,
          //     // });
          //   },
          // });
          dialogVisible.value = true;
        }else{
          router.push({name:'linkerManage',query:{id:JSON.parse(localStorage.getItem('unCreatedLinkers'))[0].link_id}});
          notification.close()
        }
      }
      const handleCurrentChange = (val) => {
        curPage.value = val;
        const end = Math.ceil(val) * 15;
        warningList.value = JSON.parse(localStorage.getItem('warningList')).slice(end - 15,end)
      };
      let bus = getCurrentInstance().appContext.config.globalProperties.$Bus; // 声明$Bus
      const mutitabsStore = useMutitabsStore()
      const siteThemeStore = useSiteThemeStore()
  
      let collapsed = ref(true)
      let imgshow = require('../assets/img/show.png')
      let imgsq = require('../assets/img/sq.png')
      let userName = ref("")
      let mobileWidth = ref(992)
      let isFullscreen = ref(mutitabsStore.isFullscreen)
  
      let colorList = ref(['#409EFF', '#536dfe','#722ed1','#009688','#52c41a','#faad14','#ff5c93', '#c62f2f', '#fd726d'])
      let colorPrimary = ref(siteThemeStore.colorPrimary || '#409EFF')
      
      function setColorPrimary() {
          siteThemeStore.setColorPrimary(colorPrimary.value)
      }
  
      let collapsedWidth=computed(()=>{
          return 'width:'+ (siteThemeStore.menuWidth+25)+'px'
      })
      let loginInnerWidth=computed(()=>{
          return 'width:'+ (siteThemeStore.menuWidth+15)+'px'
      })
  
      //路由跳转
      function jumpto(){
          mutitabsStore.switchtab('personalCenter')
      }
    //   setTimeout(()=>{
    //     notification.close()
    //   },2000)
      // 退出登录
      function exit(e) {
          ElMessageBox.confirm('退出登录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              mutitabsStore.logout('false')
              sessionStorage.clear()
              localStorage.clear()
              siteThemeStore.$reset()
              ElMessage.success('已退出登录!')
              router.replace({path: '/login'}).then(()=>{
                  window.location.reload()
              })
        })
        .catch(() => {
        })
      }
      
      // 表格序列号
      const getIndex = ($index)=> {
          // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
          return (curPage.value-1)*15 + $index +1
      }
      // 切换显示
      function toggle(showtype) {
          collapsed.value = !showtype
          bus.emit('toggle', collapsed.value)
      }
      //全屏显示
      function handleFullScreen(){
          if (!screenfull.isEnabled) {
              ElMessage.warning('您的浏览器不支持全屏!')
              return false
          }else{
              screenfull.toggle()
              isFullscreen.value = !screenfull.isFullscreen
          }
  
      }
      //设置主题
      function setSiteTheme(){
          if(siteThemeStore.siteTheme=='light'){
              siteThemeStore.setSiteTheme('dark')
          }else{
              siteThemeStore.setSiteTheme('light')
          }
      }
          //解决table 表格缩放错位问题
      function handleResize() {
          collapsed.value = isMobile()
          toggle(collapsed.value)
      }
      function isMobile() {
          let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
          if(htmlWidth>mobileWidth.value){
              return false
          }
          return true
      }
  
      onMounted(()=>{
          userName.value = mutitabsStore.userName
          window.jump = jump;
          window.addEventListener('resize', handleResize);
          nextTick(()=>{
                handleResize
          })
      })
  
      onBeforeUnmount(()=>{
          window.removeEventListener("resize", handleResize);
      })
  
  
  </script>
  <style lang="scss" scoped>
    .el-menu-demo {
      height: 56px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFFFFF;
      border-bottom: 1px solid #E5E5EA !important;
      padding: 0;

      ::v-deep(.el-menu-item.is-active) {
        background-color: transparent !important;
      }
    }

    ::v-deep(.el-menu.el-menu--horizontal) { border-bottom: none; }

    .divleft {
      display: flex;
      align-items: center;
      gap: 10px;
      padding-left: 4px;
    }

    .logoimg {
      height: 36px;
      cursor: pointer;
      display: block;
    }

    .showimg {
      width: 18px;
      height: 18px;
      cursor: pointer;
      opacity: 0.5;
      transition: opacity 0.15s;
      &:hover { opacity: 0.8; }
      &:active { border: none; }
    }

    .header-page-title {
      display: flex;
      align-items: baseline;
      gap: 10px;
      margin-left: 24px;
      flex: 1;
      min-width: 0;

      .header-title-text {
        font-size: 19px;
        font-weight: 700;
        color: #18181b;
        letter-spacing: -0.02em;
        white-space: nowrap;
        font-family: "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "PingFang SC", sans-serif;
      }

      .header-subtitle-text {
        font-size: 14px;
        color: #71717a;
        font-weight: 400;
        white-space: nowrap;
        font-family: "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "PingFang SC", sans-serif;
      }
    }

    .ly-header-right {
      display: flex;
      align-items: center;
      gap: 16px;
      padding-right: 20px;
      margin-left: auto;

      .el-badge {
        cursor: pointer;
        .el-icon { color: #6E6E73; font-size: 18px; transition: color 0.15s; }
        &:hover .el-icon { color: #1D6FE8; }
      }
    }

    .right-dropdown-center {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #1D1D1F;
      font-size: 13px;
      font-weight: 400;
      font-family: "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", "Microsoft YaHei", sans-serif;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 6px;
      transition: background 0.15s;

      &:hover { background: #F5F5F7; }

      .el-icon { color: #AEAEB2; font-size: 12px; }
    }

    ::v-deep(.el-dropdown--default) { height: 18px !important; }
    ::v-deep(.el-dropdown) { line-height: unset !important; }
    ::v-deep(.el-icon--right) { margin-left: 2px !important; }
  </style>